import { GetHelpModalLazy } from '../src/GetHelpModalLazy';
export default GetHelpModalLazy;
